import { useContext } from 'react';
import { AsyncResourceContext } from '../factories';
export var useAsyncResourceContext = function () {
    var context = useContext(AsyncResourceContext);
    return context;
};
